import { z } from "zod";
import { DisbursementStatus } from "../enums";
import { IContractorPaymentSummary } from "../../contractor-payments/IContractorPayment";
import { RouteMap } from "./customerReporting";
import { EContractorType } from "../../contractors";
import { schemes } from "../../schema-validation";

export interface IPaymentSummaryItem {
  service_date: string | null;
  work_description: string | null;
  category: string;
  earning_type: string;
  quantity: number | null;
  rate: string | null;
  amount: string;
  bill_rate: string | null;
  bill_amount: string;
}

export interface IPaymentSummaryDeduction {
  name: string;
  type: string;
  amount: string;
}

export type ContractorPaymentReporting = Pick<
  IContractorPaymentSummary,
  | "amount"
  | "business_name"
  | "companyID"
  | "contractorID"
  | "customerAccountID"
  | "first_name"
  | "full_name"
  | "group_id"
  | "last_name"
  | "pay_date"
  | "payment_type"
  | "type"
> & {
  disbursement_status: string;
  zeal_id?: string;
  net_amount?: string;
  net_pay?: string;
  total_bill_amount?: string;
  payment_items?: IPaymentSummaryItem[];
  deduction_items?: IPaymentSummaryDeduction[];
  _id: string;
};

export const paymentSummarySchema = z.object({
  amount: z.string(),
  companyID: z.string(),
  contractor_id: z.string(),
  disbursement_status: z.nativeEnum(DisbursementStatus),
  first_name: z.string(),
  group_id: schemes.uuid(),
  last_name: z.string(),
  pay_date: z.string(),
  unformatted_amount: z.number(),
  zeal_id: z.string(),
  type: z.enum([
    EContractorType.INDIVIDUAL_SOLE_PROPRIETOR,
    EContractorType.C_CORPORATION,
    EContractorType.S_CORPORATION,
    EContractorType.PARTNERSHIP,
    EContractorType.TRUST_ESTATE,
    EContractorType.LLC,
    EContractorType.OTHER,
    // TODO (Sahil, 03/28/24): Rm individual and business once all contractors are updated in production
    EContractorType.INDIVIDUAL,
    EContractorType.BUSINESS,
  ]),
});

export type PaymentSummary = z.infer<typeof paymentSummarySchema>;

export type ContractorPaymentsByPayDate<T = string> = {
  pay_date: string;
  payments_total: T;
  payments: ContractorPaymentReporting[];
};

export type PaymentSummaryPDFShape = {
  kind: RouteMap.payment_summary;
  include_intl_contractors?: boolean;
  pay_start_date: string;
  pay_end_date: string;
  payments: ContractorPaymentsByPayDate[];
};

export type PaymentSummaryCSVShape = {
  kind: RouteMap.payment_summary;
  include_intl_contractors?: boolean;
  payments: ContractorPaymentReporting[];
};
